(function($) {
    var searchToggle = $('#navbarSearchToggle');
    var searchForm = $('#navbarSearch');
    var primaryNav = $('#primaryNavigation .primary-nav');

    // Toggles search form
    searchToggle.on('click', function() {
        $this = $(this);

        /*Sets focus after delay*/
        setTimeout(function() {
            $('#navbarSearch .form-control').focus();
        }, 350);

        if($this.hasClass('is-active')) {
            $this.removeClass('is-active');
            searchForm.removeClass('is-visible');

            if ($(window).width() >= 992) {
                primaryNav.removeClass('is-hidden');
            }

        } else {
            $this.addClass('is-active');
            searchForm.addClass('is-visible');

            if ($(window).width() >= 992) {
                primaryNav.addClass('is-hidden');
            }
        }
    });

})(jQuery);
